// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parts-book[data-v-4d15807a]{min-height:617px;display:flex;flex-direction:column}.parts-book__no-results[data-v-4d15807a]{flex:1}", ""]);
// Exports
module.exports = exports;
